import * as React from 'react';
import * as update from "immutability-helper";
import { Input, Col, Row } from 'antd';

export default class Signature extends React.Component<any, any> {

    // 值变化
    changeHandler = (index: 0 | 1) => (data: string) => {
        const { value, onChange } = this.props;
        onChange && onChange(update((value || []), {
            [index]: { $set: data }
        }));
    };
    // 失焦
    blurHandler = () => {
        const { value, onBlur } = this.props;
        onBlur && onBlur(value);
    };

    render() {
        const { initialValue, placeholder, staticView, disabled } = this.props;
        return ((staticView && disabled) ?
                <Row gutter={24}>
                    <Col key='lastName' xl={4} sm={6}
                         style={{ marginBottom: 16 }}><span
                        title={initialValue && initialValue[0] || ''}>{initialValue && initialValue[0] || ''}</span></Col>
                    <Col key='firstName' xl={4} sm={6}
                         style={{ marginBottom: 16 }}><span
                        title={initialValue && initialValue[1] || ''}>{initialValue && initialValue[1] || ''}</span></Col>
                </Row> :
                <div>
                    <Input placeholder={placeholder[0]} disabled={staticView || disabled}
                           defaultValue={initialValue && initialValue[0] || ''}
                           onChange={(e: any) => this.changeHandler(0)(e.target.value)} onBlur={this.blurHandler}
                           style={{ width: "45%" }}/>
                    <Input placeholder={placeholder[1]} disabled={staticView || disabled}
                           defaultValue={initialValue && initialValue[1] || ''}
                           onChange={(e: any) => this.changeHandler(1)(e.target.value)} onBlur={this.blurHandler}
                           style={{ width: "45%", marginLeft: '10%' }}/>
                </div>
        );
    }
}
